import { extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import { useEffect, Fragment } from 'react';
import { useFloating, flip, shift, autoUpdate } from '@floating-ui/react-dom';
import Portal from '../portal/index.js';
import { useSimulateTabNavigationForReactTree } from './useSimulateTabNavigationForReactTree.js';
import { jsx, jsxs } from 'react/jsx-runtime';

var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var positionDefault = 'bottom';
var positionRight = 'right';
var positionMatchWidth = 'right';
function Popover(props) {
  var _a, _b;
  var _props$portal = props.portal,
    portal = _props$portal === void 0 ? true : _props$portal,
    targetRef = props.targetRef,
    _props$position = props.position,
    position = _props$position === void 0 ? positionDefault : _props$position,
    style = props.style,
    children = props.children,
    restProps = __rest(props, ["portal", "targetRef", "position", "style", "children"]);
  var fui = useFloating({
    middleware: [flip(), shift()],
    placement: position,
    strategy: 'fixed',
    whileElementsMounted: autoUpdate
  });
  useEffect(function () {
    fui.refs.setReference(targetRef.current);
  }, [fui, targetRef]);
  useSimulateTabNavigationForReactTree({
    triggerRef: targetRef,
    attachmentRef: fui.refs.floating
  });
  var popover = /*#__PURE__*/jsx("div", _extends({}, restProps, {
    ref: fui.refs.setFloating,
    "data-tetris-popover": true,
    style: Object.assign(Object.assign({}, style), {
      position: fui.strategy,
      top: (_a = fui.y) !== null && _a !== void 0 ? _a : 0,
      left: (_b = fui.x) !== null && _b !== void 0 ? _b : 0
    }),
    children: children
  }));
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(Portal, {
      children: portal && popover
    }), !portal && popover]
  });
}

export { Popover as default, positionDefault, positionMatchWidth, positionRight };
